import { render } from "./OptionsGrid.vue?vue&type=template&id=82183f52&scoped=true"
import script from "./OptionsGrid.vue?vue&type=script&lang=js"
export * from "./OptionsGrid.vue?vue&type=script&lang=js"

import "./OptionsGrid.vue?vue&type=style&index=0&id=82183f52&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82183f52"]])

export default __exports__